import React from "react";
import { Box, Typography } from "@mui/material";
import project1 from "../assets/images/moon_bar/moon-main.jpg";
import project2 from "../assets/images/apollo_office/apollo-main.jpg";
import project3 from "../assets/images/bothra_office/bothra-main.jpg";
import {
  motion,
  useScroll,
  useTransform,
  useSpring,
  useReducedMotion,
} from "framer-motion";
import { useNavigate } from "react-router-dom";

const features = [
  {
    img: project1,
    city: "VIP Road, Visakhapatnam",
    title: "Moon Bar & Kitchen",
    link: "/project/moonbar"
  },
  {
    img: project3,
    city: "Sampath Vinayak Temple Road, Visakhapatnam",
    title: "Bothra Shipping Corporate Office",
    link: "/project/bothra"
  },
  {
    img: project2,
    city: "Suryabagh, Visakhapatnam",
    title: "Apollo Shipping Office",
    link: "/project/apollo"
  },
];

function FeatureTile({ item }) {
  const ref = React.useRef(null);
  const reduce = useReducedMotion();
  const nav = useNavigate();
  // Per-card scroll tracking
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 80%", "end 20%"],
  });

  const prog = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  // Inner image parallax (no zoom). Stronger motion via ±30%
  const innerY = useTransform(
    prog,
    [0, 1],
    reduce ? ["0%", "0%"] : ["-30%", "30%"]
  );

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        backgroundColor: "#fff",
        borderRadius: 2,
        p: { xs: 2, md: 3 },
        boxShadow: "0 8px 24px rgba(0,0,0,.08)",
        cursor:"pointer"
      }}
      onClick={()=>nav(item.link)}
    >
      {/* Frame with overflow hidden; image moves inside */}
      <Box
        sx={{
          width: "100%",
          borderRadius: 2,
          overflow: "hidden",
          position: "relative",
          aspectRatio: "4 / 3",
          boxShadow: "0 16px 40px -24px rgba(0,0,0,.25)",
        }}
      >
        <motion.img
          src={item.img}
          alt={item.title}
          style={{
            y: innerY,
            willChange: "transform",
            width: "100%",
            height: "108%", // bleed so edges don't show during motion
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>

      {/* Static text */}
      <Box>
        <Typography
          variant="body2"
          sx={{
            color: "#777",
            letterSpacing: 1.5,
            textTransform: "uppercase",
            mb: 0.5,
          }}
        >
          {item.city}
        </Typography>
        <Typography
          variant="h5"
          sx={{ color: "#b2925a", fontWeight: 600, fontFamily: "serif" }}
        >
          {item.title}
        </Typography>
      </Box>
    </Box>
  );
}

const Features = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr" },
        gap: 3,
        px: { xs: 2, md: 2 },
        py: { xs: 6, md: 10 },
        backgroundColor: "#f9f9f9",
      }}
    >
      {features.map((item, i) => (
        <FeatureTile key={i} item={item} />
      ))}
    </Box>
  );
};

export default Features;
